// extracted by mini-css-extract-plugin
module.exports = {"FinishedQuiz":"_2KeHujPDq83i5WeRsI-CsL","success":"_2INriMCEx0o_5ZL28MiGYF","error":"_3HVNljcTWH-L_e_6V-v5eG"};